<nb-card class="dupr-modal">
    <nb-card-header class="d-flex align-items-center">
        <nb-icon class="sync-outline mr-1" icon="sync-outline"></nb-icon>
        {{ "GENERAL.SYNCHRONIZE" | translate }} DUPR ID
    </nb-card-header>
    <nb-card-body>
        <iframe [src]="urlDupr | safe: 'resourceUrl'" style="width: 100%; height: 660px"></iframe>
    </nb-card-body>
</nb-card>
